import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";

    export class WorkhoursModel extends Model  {
      key: string;
      day: number = 0;
      dayName: string;
      workhourrule: Collection = new Collection();
      
        constructor(data = null) {
            super();
            
            if(data) {
                this.createModel(data, {workhourrule: WorkhoursRule});
            }
            
        }

        public deleteRule(data) {
            if(!this.workhourrule) {
                return;
            }
            return this.workhourrule.delete(data.uid);
        }

                      
        public addRule(data) {
            if(!this.workhourrule) {
                this.workhourrule = new Collection();
            }
            this.workhourrule.add(data);
        }
            public createRule() {
                let workItemRule = new WorkhoursRule();
                return workItemRule;
            }
    }
    
    export class WorkhoursRule extends Model  {
//      uuid: string = uuid().slice(0, 8);
      key: string;
      label: string;
      start: string;
      end: string
      ;      
        constructor(data = null) {
            super();
            
            if(data) {
                this.createModel(data);
            }
            if(!this.key) {
                this.key = uuid().slice(0, 8);
            }
        }      
    }    